import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/cn";

const skeletonVariants = cva("animate-shimmer", {
  variants: {
    variant: {
      text: "h-4 w-full rounded-xs",
      card: "h-40 w-full rounded-md",
      avatar: "size-9 rounded-full",
    },
  },
  defaultVariants: { variant: "text" },
});

interface SkeletonProps extends VariantProps<typeof skeletonVariants> {
  className?: string;
}

function Skeleton({ variant, className }: SkeletonProps) {
  return (
    <div
      role="status"
      aria-label="Loading"
      className={cn(skeletonVariants({ variant }), className)}
    />
  );
}

export { Skeleton, type SkeletonProps };
